import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { BaseModel } from '@shared/base/Base.Model';

export class QuickLinkMetricsModel extends BaseModel implements IRestModel {
    public connectedDevices: number = null;
    public devicesInError: number = null;
    public devicesInWarning: number = null;
    public disconnectedDevices: number = null;

    public newDevices: number = null;
    public orphanedDevices: number = null;
    public readonly isIRestModel = true;
    public unlicensedDevices: number = null;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'EM-QuickLinkMetricsModel');
    }

    public toRestApiModel() {
        throw new Error('Method not implemented.');
    }
}
